import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/sprite-magic-troupe/Index.vue')
const LotteryRewards = () => import('../activity/sprite-magic-troupe/LotteryRewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/sprite-magic-troupe',
  name: 'activity_sprite_magic_troupe',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '精灵魔法团',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/sprite-magic-troupe/lottery-rewards',
  name: 'activity_sprite_magic_troupe_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export default [indexRoute, lotteryRewardsRoute]
